var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33342 0.366211L5.33342 8.48288L1.60008 4.74954L0.666748 5.69954L6.00008 11.0329L11.3334 5.69954L10.4001 4.74954L6.66675 8.48288L6.66675 0.366211H5.33342Z",
    fill: "#24B562"
  })));
}

export default __webpack_public_path__ + "media/67326e22.svg";
export { SvgArrowDown as ReactComponent };